import { datadogRum } from "@datadog/browser-rum";

export function captureError(e, context) {
    datadogRum.addError(e, context);
}

export function setContext(context) {
    datadogRum.setUser(context);
}